export const pack = {
  create: "Create a pack",
};
